export default __webpack_public_path__ + "static/media/under_maintenance.9c97f8ff.png";